function showQuestions(toShowClass, thisLink){
  var toShow = document.querySelector(toShowClass);
  var containers = document.querySelectorAll('.accordion-container');
  var links = document.querySelectorAll('.faq-cat-container > h2');

  containers.forEach(function(container) {
    container.style.display = 'none';
  })
  toShow.style.display = 'block';

  links.forEach(function(link) {
    link.classList.remove('faq-link-active');
  })
  thisLink.classList.add('faq-link-active');
};